/** Autocomplete de empresas: el front pide 20 en GET /companies. */
export const COMPANY_SEARCH_LIMIT = 20;

export type CompanySearchHit = {
  id: string | number;
  nombre: string;
  suspended: boolean;
};

/** Suspendida solo cuando el back manda `suspended: true`. */
export function isCompanySuspended(company: unknown): boolean {
  if (!company || typeof company !== 'object') {
    return false;
  }
  return (company as { suspended?: unknown }).suspended === true;
}

/** Extrae filas de empresa de la respuesta paginada sin alterar el orden. */
export function extractCompanyRecords(response: unknown): Record<string, unknown>[] {
  if (Array.isArray(response)) {
    return response as Record<string, unknown>[];
  }
  if (response && typeof response === 'object') {
    const obj = response as Record<string, unknown>;
    if (Array.isArray(obj['companies'])) {
      return obj['companies'] as Record<string, unknown>[];
    }
    if (Array.isArray(obj['data'])) {
      return obj['data'] as Record<string, unknown>[];
    }
    if (obj['id'] != null || obj['company_id'] != null) {
      return [obj];
    }
  }
  return [];
}

/** Mapeo común para autocompletados GET /companies (conserva orden del API). */
export function mapCompanySearchOptions(response: unknown): CompanySearchHit[] {
  return extractCompanyRecords(response).map((company) => ({
    id: (company['id'] || company['company_id']) as string | number,
    nombre: (company['name'] || company['nombre'] || company['company_name'] || 'Sin nombre') as string,
    suspended: isCompanySuspended(company),
  }));
}
